import { Injectable } from '@angular/core';
import { CounterResultAdapter } from './counter-result.adapter';
import { ProductListComponentService } from '@spartacus/storefront';
import { map, Observable } from 'rxjs';
import { SearchPagesService } from '../../../../content-pages/search-pages/core/search-pages.service';
import { SearchLiteraturesService } from '../../../../content-pages/search-literatures/core/search-literatures.service';

@Injectable({
  providedIn: 'root',
})
export class CounterResultService {
  constructor(
    private counterResultAdapter: CounterResultAdapter,
    private searchPagesService: SearchPagesService,
    private productListComponentService: ProductListComponentService,
    private searchLiteraturesService: SearchLiteraturesService,
  ) {}

  getQtyContent(query: string, isSearchPage: boolean): Observable<number> {
    if (isSearchPage) {
      return this.searchPagesService.get().pipe(map(data => data?.pagination?.totalResults || 0));
    }

    return this.counterResultAdapter.headContent(query).pipe(map(data => data));
  }

  getQtyProduct(query: string, isSearchPage: boolean) {
    if (isSearchPage) {
      return this.counterResultAdapter.headProduct(query).pipe(map(data => data));
    }

    return this.productListComponentService.model$.pipe(map(data => data?.pagination?.totalResults || 0));
  }

  getQtyLiterature(query: string, isSearchLiteraturePage: boolean) {
    if (isSearchLiteraturePage) {
      return this.searchLiteraturesService.get().pipe(map(data => data?.pagination?.totalResults || 0));
    }

    return this.counterResultAdapter.headLiterature(query).pipe(map(data => data));
  }
}
